import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  GeofenceCategory,
  GeofenceCategoryCreateInput,
  GeofenceCategoryUpdateInput,
} from '@models/geofence.model';
import { geofenceService } from '@services/geofence';
import { GEOFENCE_CATEGORIES_QUERY_KEY } from './useGeofenceCategories';

const invalidateAllCategoryQueries = (queryClient: ReturnType<typeof useQueryClient>) => {
  queryClient.invalidateQueries({ queryKey: GEOFENCE_CATEGORIES_QUERY_KEY });
};

export const useCreateGeofenceCategory = () => {
  const queryClient = useQueryClient();

  return useMutation<GeofenceCategory, Error, GeofenceCategoryCreateInput>({
    mutationFn: (input) => geofenceService.createGeofenceCategory(input),
    onSuccess: () => invalidateAllCategoryQueries(queryClient),
  });
};

export const useUpdateGeofenceCategory = () => {
  const queryClient = useQueryClient();

  return useMutation<GeofenceCategory, Error, GeofenceCategoryUpdateInput>({
    mutationFn: (input) => geofenceService.updateGeofenceCategory(input),
    onSuccess: () => invalidateAllCategoryQueries(queryClient),
  });
};

export const useUpdateGeofenceCategorySortOrder = () => {
  const queryClient = useQueryClient();

  return useMutation<GeofenceCategory[], Error, string[]>({
    mutationFn: (categoryIds) =>
      geofenceService.updateGeofenceCategorySortOrder(categoryIds),
    onSuccess: () => invalidateAllCategoryQueries(queryClient),
  });
};

export const useDeleteGeofenceCategory = () => {
  const queryClient = useQueryClient();

  return useMutation<{ affected: number }, Error, string>({
    mutationFn: (geofenceCategoryId) =>
      geofenceService.deleteGeofenceCategory(geofenceCategoryId),
    onSuccess: () => invalidateAllCategoryQueries(queryClient),
  });
};
